import styled from "@emotion/styled";
import { colors } from "../../../theme/colors";

export const ContentContainer = styled.div`
  height: 200px;
  text-align: center;
`;

export const Title = styled.h2`
  font-family: "Sora", sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: ${colors.text.primary};
  margin: 0 0 12px 0;
`;

export const Description = styled.p`
  font-family: "Nunito", sans-serif;
  font-size: 16px;
  color: ${colors.text.secondary};
  margin: 0 0 32px 0;
  line-height: 1.5;
`;

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

